import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap';
import toast from 'react-hot-toast';
import useAuthentication from '../../../hooks/useAuthentication';
import styles from './Profile.module.css';

const ChangePassword = () => {
  const { changePassword, isDisable } = useAuthentication();
  const [isChangingPassword, setIsChangingPassword] = useState(false);
  const [isSubmittingPassword, setIsSubmittingPassword] = useState(false);
  const [passwordData, setPasswordData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const handlePasswordInputChange = (e) => {
    const { name, value } = e.target;
    setPasswordData({
      ...passwordData,
      [name]: value,
    });
  };

  const handleChangePasswordToggle = () => {
    if (isChangingPassword) {
      // Reset form data when canceling
      setPasswordData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
    }
    setIsChangingPassword(!isChangingPassword);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setIsSubmittingPassword(true);

    // Validation
    if (!passwordData.oldPassword) {
      toast.error('Please enter your current password');
      setIsSubmittingPassword(false);
      return;
    }

    if (!passwordData.newPassword || passwordData.newPassword.length < 6) {
      toast.error('New password must be at least 6 characters long');
      setIsSubmittingPassword(false);
      return;
    }

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      toast.error('New passwords do not match');
      setIsSubmittingPassword(false);
      return;
    }

    if (passwordData.oldPassword === passwordData.newPassword) {
      toast.error('New password must be different from current password');
      setIsSubmittingPassword(false);
      return;
    }

    try {
      await changePassword(passwordData.oldPassword, passwordData.newPassword);
      setPasswordData({
        oldPassword: '',
        newPassword: '',
        confirmPassword: '',
      });
      setIsChangingPassword(false);
    } catch (error) {
      // Error is already handled in the hook
    } finally {
      setIsSubmittingPassword(false);
    }
  };

  return (
    <div className={styles.password__section}>
      <div className={styles.password__header}>
        <h3>Security</h3>
        {!isChangingPassword ? (
          <button onClick={handleChangePasswordToggle} className={styles.edit__btn}>
            Change Password
          </button>
        ) : (
          <>
            <button onClick={handleChangePasswordToggle} className={styles.cancel__btn}>
              Cancel
            </button>
            <button
              onClick={handlePasswordSubmit}
              className={styles.save__btn}
              disabled={isSubmittingPassword || isDisable}
            >
              {isSubmittingPassword ? 'Updating...' : 'Update Password'}
            </button>
          </>
        )}
      </div>

      {isChangingPassword && (
        <form onSubmit={handlePasswordSubmit} className={styles.password__form}>
          <Row className="g-3">
            <Col md={12}>
              <div className={styles.form__group}>
                <label htmlFor="oldPassword">Current Password</label>
                <input
                  type="password"
                  id="oldPassword"
                  name="oldPassword"
                  value={passwordData.oldPassword}
                  onChange={handlePasswordInputChange}
                  placeholder="Enter your current password"
                  required
                  autoComplete="current-password"
                />
              </div>
            </Col>
            <Col md={6}>
              <div className={styles.form__group}>
                <label htmlFor="newPassword">New Password</label>
                <input
                  type="password"
                  id="newPassword"
                  name="newPassword"
                  value={passwordData.newPassword}
                  onChange={handlePasswordInputChange}
                  placeholder="Enter new password"
                  required
                  autoComplete="new-password"
                />
                <small className={styles.help__text}>Minimum 6 characters</small>
              </div>
            </Col>
            <Col md={6}>
              <div className={styles.form__group}>
                <label htmlFor="confirmPassword">Confirm New Password</label>
                <input
                  type="password"
                  id="confirmPassword"
                  name="confirmPassword"
                  value={passwordData.confirmPassword}
                  onChange={handlePasswordInputChange}
                  placeholder="Confirm new password"
                  required
                  autoComplete="new-password"
                />
              </div>
            </Col>
          </Row>
        </form>
      )}
    </div>
  );
};

export default ChangePassword;
